import { useEffect, useState } from "react";

function useMedia(queries: any, values: any, defaultValue: any) {
  const mediaQueryLists = queries.map((q: any) => window.matchMedia(q));

  const getValue = () => {
    const index = mediaQueryLists.findIndex((mql: any) => mql.matches);
    return typeof values[index] !== "undefined" ? values[index] : defaultValue;
  };

  const [value, setValue] = useState(getValue);

  useEffect(() => {
    const handler = () => setValue(getValue);
    mediaQueryLists.forEach((mql: any) => mql.addListener(handler));
    return () =>
      mediaQueryLists.forEach((mql: any) => mql.removeListener(handler));
  }, []);

  return value;
}

export default useMedia;
